import React from 'react';
import autoBind from 'react-autobind';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import { sortAlphaByKey } from '../../../lib';
import { Subscribe, appContainer } from '../../../contexts/app';

import ContentAddIcon from 'material-ui/svg-icons/content/add';

import SidebarIcon from '../components/SidebarIcon';
import SidebarLink from '../components/SidebarLink';
import { Sidebar } from '../';
import style from './style.js';
import './style.scss';

class SidebarMarkerTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
    autoBind(this);
  }

  render() {
    const { match } = this.props;
    const {
      markerTypes,
      markerType,
      categories,
      facilityId,
      currentUser
    } = this.props;
    const categoryMap = categories
      .sort((a, b) => sortAlphaByKey(a, b, 'name'))
      .reduce((categoryMap, category) => {
        return Object.assign({}, categoryMap, {
          [category._id]: {
            name: category.name,
            types: markerTypes
              .filter(markerType => markerType.category_id === category._id)
              .sort((a, b) => sortAlphaByKey(a, b, 'name'))
          }
        });
      }, {});
    const { permissions } = currentUser;
    const listWidth = permissions.edit.resources ? null : 306;
    return (
      <div id="SidebarMarkerTypes">
        <Sidebar>
          {permissions.edit.resources && (
            <div className="icon-wrapper">
              <SidebarIcon match={match} matchFacilityId={facilityId} />
            </div>
          )}
          <div className="list-wrapper" style={{ width: listWidth }}>
            {Object.keys(categoryMap).map(categoryId => {
              const markerTypesByCat = categoryMap[categoryId].types;
              const contegoryName = categoryMap[categoryId].name;
              return (
                <div key={categoryId}>
                  <MenuItem
                    primaryTogglesNestedList
                    nestedListStyle={style.nestedList}
                    nestedItems={markerTypesByCat.map(_markerType => (
                      <div key={_markerType._id}>
                        <SidebarLink
                          to={`/marker-types/${
                            _markerType._id
                          }?facilityId=${facilityId}`}
                        >
                          <MenuItem
                            style={
                              markerType && markerType._id === _markerType._id
                                ? style.activeMarkerType
                                : {}
                            }
                            leftIcon={
                              <img
                                src={_markerType.image.path}
                                alt={_markerType.name}
                              />
                            }
                          >
                            {_markerType.name}
                          </MenuItem>
                        </SidebarLink>
                      </div>
                    ))}
                  >
                    {contegoryName}
                  </MenuItem>
                  <Divider />
                </div>
              );
            })}
            <SidebarLink to={`/marker-types?facilityId=${facilityId}`}>
              <MenuItem rightIcon={<ContentAddIcon />}>
                New Marker Type
              </MenuItem>
            </SidebarLink>
            <Divider />
          </div>
        </Sidebar>
      </div>
    );
  }
}

SidebarMarkerTypes.propTypes = {
  // markerTypes: PropTypes.array.isRequired
};

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        return (
          <SidebarMarkerTypes
            {...props}
            currentUser={app.state.get('currentUser')}
          />
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMarkerTypes/index.jsx